import { MemberInfo } from "./type"

// 扁平化数据：将 properties 数据扁平化到每一行数据中
export const transformBaseInfoTableData = (tableData: MemberInfo[]) => {
    return tableData.map(item => {
        const flattenedItem = { ...item }

        // 将 properties 数据扁平化
        if (item.properties && Array.isArray(item.properties)) {
            item.properties.forEach(prop => {
                flattenedItem[`attr_${prop.name}`] = prop.value
                flattenedItem[`type_${prop.name}`] = prop.type
            })
        }

        return flattenedItem
    })
}